import React, { useEffect, useRef } from "react";

/**
 * Official mortgage-quote.me lenders carousel (mid-page).
 * Vendor script auto-injects the carousel adjacent to its <script> tag.
 */
const SCRIPT_ID = "mqlenderscarousel";
const SCRIPT_SRC =
    "https://frontend.mortgage-quote.me/calculators/carousel/mq-lenders-carousel.js?id=69ea34dcffff3f4c2c9b5d36&theme=colour&pause=false&hover=false";

export default function MQLendersCarousel() {
    const hostRef = useRef(null);

    useEffect(() => {
        const host = hostRef.current;
        if (!host) return;

        // Always inject a fresh script on each mount with a cache-busting
        // query param — guarantees the vendor IIFE re-executes after SPA
        // navigations and re-renders the carousel.
        const s = document.createElement("script");
        s.id = SCRIPT_ID;
        s.src = `${SCRIPT_SRC}&_t=${Date.now()}`;
        host.appendChild(s);

        return () => {
            try {
                s.remove();
            } catch (_) {
                /* noop */
            }
            if (host) host.innerHTML = "";
        };
    }, []);

    return (
        <section
            data-testid="mq-lenders-carousel-section"
            className="relative py-12 md:py-16 bg-brand-surface border-y border-brand-border"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
                <div>
                    <div className="text-center mb-10">
                        <div className="text-[11px] uppercase tracking-[0.24em] text-brand-accent font-bold mb-3">
                            Our lender panel
                        </div>
                        <h3 className="font-serif-editorial text-3xl sm:text-4xl text-brand-primary">
                            Compared daily, across a large panel of UK lenders.
                        </h3>
                    </div>
                </div>
                <div>
                    <div
                        ref={hostRef}
                        data-testid="mq-lenders-carousel-host"
                        className="min-h-[110px]"
                    />
                </div>
            </div>
        </section>
    );
}
